import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import ProjectCatty from './ProjectCatty'
import ProjectPlity from './ProjectPlity'
import ProjectGrowup from './ProjectGrowup'
import ProjectUha from './ProjectUha'
import ProjectSerendipity from './ProjectSerendipity'
import { colors } from './config/colors'
import { screenshots } from './config/screenshots'
import { reviews } from './config/reviews'
import { summary } from './config/summary'
import { contribution } from './config/contribution'
import ProjectLawLogging from './ProjectLawLogging'

export const ProjectDialogContent = styled(DialogContent)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingRight: '50px',
    paddingLeft: '50px',
    paddingTop: '20px',
    paddingBottom: '20px'
  },
}))

export default function ProjectDetail({ open, setOpen, title }) {
  function SelectedDetail({ title }) {
    switch (title) {
      case '[Dearplants] Plity':
        return (
          <ProjectPlity
            color={colors[title]}
            screenshots={screenshots[title]}
            reviews={reviews[title]}
            summary={summary[title]}
            contribution={contribution[title]}
          />
        )
      case 'Catty — Knowledge-Eating Cat':
        return (
          <ProjectCatty
            color={colors[title]}
            screenshots={screenshots[title]}
            summary={summary[title]}
            contribution={contribution[title]}
          />
        )
      case 'Grow Up':
        return (
          <ProjectGrowup
            color={colors[title]}
            screenshots={screenshots[title]}
            summary={summary[title]}
            contribution={contribution[title]}
          />
        )
      case '[Ulimbridge] Psychology-based dating app':
        return (
          <ProjectSerendipity
            color={colors[title]}
            screenshots={screenshots[title]}
            summary={summary[title]}
            contribution={contribution[title]}
          />
        )
      case 'UHA — One-stop childcare service':
        return (
          <ProjectUha
            color={colors[title]}
            screenshots={screenshots[title]}
            summary={summary[title]}
            contribution={contribution[title]}
          />
        )
      case '[Kai-i Company] Lawlogging':
        return (
          <ProjectLawLogging
            color={colors[title]}
            screenshots={screenshots[title]}
            summary={summary[title]}
            contribution={contribution[title]}
          />
        )
      default:
        break
    }
  }

  return (
    <Dialog
      fullWidth
      maxWidth='lg'
      open={open}
      onClose={() => setOpen(false)}
    >
      <Typography sx={{ px: { xs: 3, md: '50px' }, pt: 4, pb: 1, color: 'text.secondary', fontSize: '1rem' }}>Hover over Korean text to see its English translation.</Typography>
      <SelectedDetail title={title} />
    </Dialog>
  )
}

ProjectDetail.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  title: PropTypes.string,
}
